enum BonusStatusDto {
    Expired = 'expired',
    Complete = 'complete',
    Running = 'running',
    InProgress = 'inprogress',
    New = 'new',
}

export default BonusStatusDto;
